import React from 'react'

// import { Link } from '../components/utils/SmartLink'
import { Layout } from '../components/Layout'
import { Page } from '../components/Page'
import { Island, IslandCaption } from '../components/Island'
import { ContentPassThrough } from '../components/ContentViewer'
import styled from 'styled-components'

// const RedheadedGirlPhoto = `/img/family-day-harvest-0316.jpg`
const RedheadedGirlPhoto = `/img/homepage_girl_lightweight.jpg`
// const CabinPhoto = `/img/exhibits1.jpg`

const CenteredH1 = styled.h1`
  text-align:center;
`

const Homepage = () => {
  return (
    <Layout>
      <Page title='Our Past, Our Future' subtitle='The Northeast Georgia History Center' fullBleed>
        <Island image={RedheadedGirlPhoto}>
          <IslandCaption>
            <ContentPassThrough>
              <CenteredH1>Our Mission</CenteredH1>
              <p>The Northeast Georgia History Center is dedicated to preserving and sharing our regional history and being our community’s pathway to history education. Through our educational programs, community events, exhibits, and historic structures, we strive to be a leading resource for promoting a greater understanding of local, state, and national history.</p>
            </ContentPassThrough>
          </IslandCaption>
        </Island>
        {/* <Island image={CabinPhoto}>
          <IslandCaption alignment='center'>
            <ContentPassThrough>
              <CenteredH1>Visit Us</CenteredH1>
                Hours <br />
                Tuesday - Saturday 10AM - 4PM <br />
                (Closed Sundays & Mondays) <br />
              <br />
                Admission <br />
                Members are always <strong>FREE!</strong> <br />
                $6 for adults <br />
                $5 Active & Retired military <br />
                $5 for Seniors (65 and over) <br />
                $4 for students (including college students with an ID) <br />
              <strong>Free</strong> for Children 5 and under. <br />
              <br />
              <Link to='https://goo.gl/maps/V47jxnMfXJs'>Directions</Link>
            </ContentPassThrough>
          </IslandCaption>
        </Island> */}
      </Page>
    </Layout>
  )
}

export default Homepage
